<template>
    <div class="page-exam">
        <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'การสอบวัดผล - ProbPlus', 
                'Exam - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'เงื่อนไขและข้อตกลงในการสอบวัดผลเพื่อขอใบรับรองโดยปปง.',
                'เงื่อนไขและข้อตกลงในการสอบวัดผลเพื่อขอใบรับรองโดยปปง.')" />
        <section class="top-title">
            <div class="container">
                <h1>{{ $PPlusEngine.getDictionary($route.params.lang, 'การสอบวัดผล', 'Exam') }}</h1>
            </div>
        </section>
        <div class="container">
            <section class="objective">
                <div class="global-box-content" v-if="$route.params.lang == 'th'">
                    <h2>เงื่อนไขและข้อตกลงในการสอบ</h2>
                    <article>
                        <p>
                            บริษัท โปรเฟสชั่นแนล บี โพสิทีฟ จำกัด ซึ่งได้รับความเห็นชอบจากสำนักงานป้องกันและปราบปรามการฟอกเงิน และหลักสูตรตาม “ระเบียบคณะกรรมการป้องกันและปราบปรามการฟอกเงินว่าด้วยการจัดให้มีการฝึกอบรมให้แก่ผู้มีหน้าที่รายงานตามมาตรา 13 และมาตรา 16 พ.ศ. 2563” จำเป็นต้องจัดการทดสอบความรู้ความเข้าใจของผู้ฝึกอบรมตามมาตรฐานที่สำนักงานป้องกันและปราบปรามการฟอกเงินกำหนด โดยการทดสอบผ่านระบบเทคโนโลยีสารสนเทศทางอินเตอร์เน็ตเพื่อการควบคุมการฝึกอบรมให้เป็นไปตามหลักสูตรการฝึกอบรมที่ได้รับความเห็นชอบ
                        </p>
                        <p>
                            แบบทดสอบเป็นปรนัย <strong>รวมทั้งสิ้น 50 ข้อ กำหนดเวลาทำข้อสอบ 2 ชั่วโมง</strong> ประกอบไปด้วย 6 หมวดวิชา ดังนี้
                        </p>
                        <ol>
                            <li>ความรู้เบื้องต้นเกี่ยวกับกฏหมายว่าด้วยการป้องกันและปราบปรามการฟอกเงินและกฏหมายว่าด้วยการป้องกันและปราบปรามการสนับสนุนทางการเงินแก่การก่อการร้ายและการแพร่ขยายอาวุธที่มีอานุภาพทำลายล้างสูง</li>
                            <li>การประเมิน การบริหาร และการบรรเทาความเสี่ยงด้านการฟอกเงินและการสนับสนุนทางการเงินแก่การก่อการร้ายและการแพร่ขยายอาวุธที่มีอานุภาพทำลายล้างสูง และแนวทางปฏิบัติที่เกี่ยวข้อง</li>
                            <li>การจัดทำรายงานการทำธุรกรรม และแนวทางปฏิบัติที่เกี่ยวข้อง</li>
                            <li>การจัดให้ลูกค้าแสดงตน และแนวทางปฏิบัติที่เกี่ยวข้อง</li>
                            <li>การตรวจสอบเพื่อทราบข้อเท็จจริงเกี่ยวกับลูกค้า การเก็บรักษาข้อมูล และแนวทางปฏิบัติที่เกี่ยวข้อง</li>
                            <li>การตรวจสอบรายชื่อบุคคลที่ถูกกำหนด การระงับการดำเนินการกับทรัพย์สิน และการรายงานสำนักงาน และแนวทางปฏิบัติที่เกี่ยวข้อง</li>
                        </ol>
                        <p>
                            ทั้งนี้ บริษัท โปรเฟสชั่นแนล บี โพสิทีฟ จำกัด จะดำเนินการออกใบประกาศนียบัตรรับรองการสำเร็จหลักสูตร ให้กับผู้ฝึกอบรมที่ผ่านการทดสอบตามมาตรฐานที่สำนักงานป้องกันและปราบปรามการฟอกเงินกำหนด โดย<strong>ไม่น้อยกว่าร้อยละ 70 เท่านั้น</strong>
                        </p>
                        <p>
                            ในกรณีที่ผู้ฝึกอบรมใด ไม่ผ่านการทดสอบตามมาตรฐานที่สำนักงานป้องกันและปราบปรามการฟอกเงินกำหนดตามเกณฑ์ข้างต้น ผู้ฝึกอบรมจำเป็นต้องปฏิบัติตามข้อกำหนด และข้อเสนอแนะของบริษัท โปรเฟสชั่นแนล บี โพสิทีฟ จำกัด เพื่อทำการทดสอบใหม่ โดยผู้ฝึกอบรมจะเป็นผู้รับผิดชอบค่าบริการและธรรมเนียมต่างๆ ที่อาจเกิดขึ้นด้วยตนเอง ตามรายละเอียดหน้า “การชำระเงิน”
                        </p>
                        <p>
                            ทั้งนี้ การลงทะเบียนและชำระเงินเพื่อทำการทดสอบใหม่จะไม่สามารถแจ้งยกเลิกบริการได้
                        </p>
                    </article>
                </div>
                <div class="global-box-content" v-if="$route.params.lang == 'en'">
                    <h2>Exam terms and conditions</h2>
                    <article>
                        <p>
                            Professional be Positive Co., Ltd. which has been approved by the Anti-Money Laundering Office presents a course, “Regulation of the Anti-Money Laundering Committee on Providing Training for Persons Responsible to Report under Section 13 and Section 16, 2563", is required to conduct a test of knowledge and understanding of trainees according to the standards. At the Anti-Money Laundering Office By testing through the Internet-based information technology system for training control in accordance with the approved training course.
                        </p>
                        <p>
                            The test is a multiple choice, <strong>totaling 50 questions with a time limit of 2 hours</strong>, and consists of 6 modules as follows:
                        </p>
                        <ol>
                            <li>Fundamental of Anti-Money Laundering and Counter-Terrorism and Proliferation of Weapon of Mass Destruction Financing Act</li>
                            <li>Assessment, Management and Mitigation of Money Laundering and Proliferation of Weapon of Mass Destruction Financing Risks and Related Practices</li>
                            <li>Transaction Reporting and Related Practices</li>
                            <li>Know Your Customer (KYC) and Related Practices</li>
                            <li>Customer Due Diligence, Record Retention, and Related Practices</li>
                            <li>Designated Persons Name Screening, Suspension of Property and Reporting and Related Practices</li>
                        </ol>
                        <p>
                            Professional be Positive Co., Ltd. will issue a certificate of course completion to trainees who have passed the test according to the standard set by the Anti-Money Laundering Office with the score <strong>must not be less than 70 percent</strong>.
                        </p>
                        <p>
                            In the event that any trainee failed to pass the test according to the standard mentioned above, trainees will need to conduct a new test. The trainees will be responsible for any extra fees that may occur according to the details on the "Payment" page.
                        </p>
                        <p>
                            Please note that registration and payment for the testing once made will not be able for cancellation.
                        </p>
                    </article>
                </div>
                <div class="action">
                    <button class="btn btn-main btn-lg" @click="goToExam()">{{ $PPlusEngine.getDictionary($route.params.lang, 'เข้าสู่สนามสอบ', 'Start the Exam') }}</button>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import PPlusNotify from '@/resources/PPlusNotify';

export default {
    mixins: [PPlusNotify],
    methods: {
        goToExam() {
            let loader = this.$WeHelper.modalLoad();
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {};

            this.$WeHelper.postAPI(apiURL, '/api/exam/validate-course', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                loader.hide();

                if (response.data.allow) {
                    this.$router.push('/' + this.$route.params.lang + '/exam/room');
                }
                else if (!response.data.isAuthen) {
                    this.alertPleaseLogin();
                }
                else if (response.data.paymentStatus == this.$PPlusConstant.PaymentStatus_None) {
                    this.alertPleaseMakePayment(this.$router);
                }
                else if (response.data.paymentStatus == this.$PPlusConstant.PaymentStatus_NeedPayExam) {
                    this.alertPleaseMakePaymentForExam(this.$router);
                }
                else if (response.data.paymentStatus == this.$PPlusConstant.PaymentStatus_WaitForConfirm) {
                    this.alertPleaseWaitForPaymentConfirm();
                }
                else if (response.data.examStatus == this.$PPlusConstant.ExamStatus_PendingClass) {
                    this.$swal({
                        title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'คุณยังเรียนบทเรียนไม่ครบ', 
                                        'Module Attendance Required'),
                        text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'เนื่องจากนโยบายของทางปปง. ท่านจำเป็นต้องมีชั่วโมงเรียนให้ครบตามกำหนดก่อนจึงจะสอบวัดผลได้ โดยต้องทำการเข้าเรียนและดาวน์โหลดเอกสารบทเรียนของทุกบท โปรดดูรายการบทเรียนที่คุณยังเรียนไม่จบ', 
                                        'Due to AMLO\'s policy, it is required to attend all modules, chapters, and download all materials before taking the exam.'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#cc4a4e',
                        cancelButtonColor: '#ccc',
                        confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ดูรายการบทเรียน', 
                                        'See Attendance Details')
                    }).then((result) => {
                        if (result.value) {
                            this.$router.push('/' + this.$route.params.lang + '/user/profile');
                        }
                    });
                }
                else if (response.data.examStatus == this.$PPlusConstant.ExamStatus_PassExam) {
                    this.$swal({
                        title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ท่านได้ผ่านการสอบวัดผลเรียบร้อยแล้ว', 
                                        'You have already passed the exam!'),
                        text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ต้องการที่จะไปหน้าดาวน์โหลดใบรับรองหรือไม่', 
                                        'Do you want to download the certificate?'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#cc4a4e',
                        cancelButtonColor: '#ccc',
                        confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ดาวน์โหลดใบรับรอง', 
                                        'Download Certificate')
                    }).then((result) => {
                        if (result.value) {
                            this.$router.push('/' + this.$route.params.lang + '/user/certificate');
                        }
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-exam {
    padding-bottom: 40px;

    .top-title {
        background-image: url(../assets/exam-bg.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        display: flex;
        align-items: center;
        width: 100%; 
        height: 180px;
        margin-bottom: 40px;

        h1 {
            margin: 0;
            font-size: 48px;
            font-weight: 200;
            color: #fff;
            text-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
            text-align: center;
        }
    }

    .objective {
        h2 {
            font-size: 22px;
            font-weight: 200;
            color: $mainColor;
            margin: 0;
            padding-bottom: 20px;

            &:after {
                content: " ";
                display: block;
                width: 100px;
                height: 1px;
                background: #ccc;
                margin-top: 15px;
            }
        }

         article {
            font-size: 14px;
            line-height: 26px;
            color: #333;

            h4 {
                font-weight: bold;
                font-size: 18px;
            }

            p, ul {
                margin: 20px 0;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            img {
                display: block;
                max-width: 100%;
                margin: 30px auto;

                &:first-child {
                    margin-top: 0;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }

            img + p {
                padding: 20px 0;
            }
        }
    }

    .action {
        margin-top: 20px;
        text-align: center;
    }
}
</style>